import React, { useEffect, useRef, useState } from "react";
import Row from "../../common/layout/row";
import Select from "../../common/form/select";

export function PermissaoUC(props) {
    const [filtroUc, setFiltroUc] = useState("");
    const [filtroCli, setFiltroCli] = useState(null);
    const [listaOriginal, setListaOriginal] = useState(props.unidades_consumidoras_usuario);

    useEffect(() => {
        if (props.unidades_consumidoras_usuario && props.unidades_consumidoras_usuario.length) {
            // Filtra apenas as UCs "permitidas" para o usuário logado
            const ucsFiltradas = props.unidades_consumidoras_usuario.filter(
                (ucu) => ucu.permitida
            );
            setListaOriginal(ucsFiltradas);
        } else {
            setListaOriginal([]);
        }
    }, [props.unidades_consumidoras_usuario]);

    const containerRef = useRef();
    const handleMouseLeaveUCsUsuario = () => {
        //  Itera sobre os refs e reseta o scroll de cada div
        if (containerRef && containerRef.current) {
            containerRef.current.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    if (!listaOriginal.length) return null;

    const listaFiltrada = listaOriginal
        .filter((ucu) => {
            const filtroCliValido = !filtroCli || ucu.id_cliente == filtroCli;
            const listaString = String(ucu.numero_nome).split(" - "); //separa por -, mas pode ter mais de um, então o primeiro elemento é o numero e o resto das strings é o nome
            const numero = listaString.shift();
            const nome = listaString.join(" - ");
            const filtroUcValido = !filtroUc || numero.includes(filtroUc) || nome.toLowerCase().includes(filtroUc.toLowerCase());
            return filtroCliValido && filtroUcValido;
        })
        .sort((a, b) => a.id_cliente - b.id_cliente);

    const listaFiltradaVazia = !listaFiltrada.length;
    const todasUcsFiltradaDesmarcadas = !listaFiltradaVazia && listaFiltrada.every((item) => !item.permitida);
    const todasUcsListaOriginalDesmarcadas = listaOriginal.every((item) => !item.permitida);

    return (
        <div>
            <div className="p-2">
                {props.usuarioLogado && props.usuarioLogado.administrador ? (
                    <Row>
                        <Select
                            name="id_cliente"
                            options={props.listaCliente.filter((cli) => cli.id !== "admin")}
                            isMulti={false}
                            cols="12 12 12 12"
                            placeholder="Selecione o Cliente"
                            value={filtroCli}
                            onChange={(value) => {
                                setFiltroCli(value);
                            }}
                        />
                    </Row>
                ) : null}
                <input className="form-control" type="text" placeholder="Filtrar pelo nº ou nome da UC" onChange={(e) => setFiltroUc(e.target.value)} value={filtroUc} />
                <button
                    className="form-control btn btn-danger mx-0 mt-2"
                    disabled={props.readOnly || listaFiltradaVazia}
                    type="button"
                    onClick={() => {
                        //se todas as UCs filtradas estão marcadas, desmarcar todas, se não, marcar todas
                        const novoEstado = todasUcsFiltradaDesmarcadas || todasUcsListaOriginalDesmarcadas ? true : false;
                        const listaAtualizada = listaOriginal.map((item) => ({
                            ...item, //se ta filtrada altera ela, senão deixa o valor que estava
                            permitida: listaFiltrada.find((uc) => uc.id_unidade_consumidora == item.id_unidade_consumidora) ? novoEstado : item.permitida,
                        }));

                        //se tiver alguma permitida na lista original atualiza permissões do servidor
                        if (listaAtualizada.find((item) => item.permitida)) {
                            props.setPermissaoUnidadeConsumidora({
                                id_usuario: props.id_usuario,
                                unidades_consumidoras_usuario: listaAtualizada,
                            });
                        } else {
                            //senao, atualiza apenas o state e exibe a mensagem pro cara selecionar uma pra finalmente salvar
                            setListaOriginal(listaAtualizada);
                            window.confirm("A lista de UCs permitidas não pode ficar vazia, selecione pelo menos uma UC para salvar as alterações");
                        }
                    }}
                >
                    {listaFiltrada.find((item) => item.permitida) ? "Desmarcar Todas" : "Marcar Todas"}
                    {filtroCli ? " do cliente selecionado" : ""}
                </button>
            </div>
            <div
                ref={containerRef}
                onMouseLeave={() => {
                    handleMouseLeaveUCsUsuario();
                    setFiltroUc("");
                }}
                className="d-flex flex-column custom-scroll"
                style={{ border: "1px solid #DDD", borderRadius: 5, height: 120, padding: 10, overflowY: "scroll" }}
            >
                {listaFiltrada.map((ucu) => (
                    <div
                        className={`btn small ${ucu.permitida ? "btn-success" : "btn-light"} ${props.readOnly ? "disabled" : ""} p-1 m-1`}
                        onClick={() => {
                            if (props.readOnly) return;

                            const listaAtualizada = listaOriginal.map((item) => ({
                                ...item,
                                permitida: ucu.id_unidade_consumidora == item.id_unidade_consumidora ? !item.permitida : item.permitida,
                            }));
                            if (listaAtualizada.find((item) => item.permitida)) {
                                props.setPermissaoUnidadeConsumidora({
                                    id_usuario: props.id_usuario,
                                    unidades_consumidoras_usuario: listaAtualizada,
                                });
                            } else {
                                setListaOriginal(listaAtualizada);
                                window.confirm("A lista de UCs permitidas não pode ficar vazia, selecione pelo menos uma UC para salvar as alterações");
                            }
                        }}
                    >
                        {ucu.numero_nome}
                    </div>
                ))}
            </div>
        </div>
    );
}
